// Risk tier boundaries, severity 0..1 to tier 1..3.
// Single source of truth shared by both the frontend tool (hotspots,
// annotations, badges) and fixtures/tests.

export const RISK_TIER_BANDS = Object.freeze([
  Object.freeze({ max: 0.6, tier: 1 }),
  Object.freeze({ max: 0.8, tier: 2 }),
  Object.freeze({ max: Infinity, tier: 3 }),
]);

export function severityToRiskTier(severity) {
  for (const band of RISK_TIER_BANDS) {
    if (severity < band.max) return band.tier;
  }
  // Defensive: the Infinity sentinel guarantees the loop returns. If
  // a researcher edits RISK_TIER_BANDS and drops the trailing tier,
  // we still return *something* readable instead of undefined.
  return RISK_TIER_BANDS[RISK_TIER_BANDS.length - 1].tier;
}
